import { DateTime } from 'luxon';
import { assoc, lensProp, mergeLeft, over, pipe, when } from 'ramda';
import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { DATE_FORMATS_TYPES } from '../constants';
import { initAndGetIsShowTranslationKeys } from '../utils';
import { LANG_CURRENCY_SIGNS } from '../utils/currencyFormats';

export const initialState = {
  language: 'en',
  timezone: DateTime.local().zoneName,
  dateFormats: DATE_FORMATS_TYPES,
  currencyFormats: LANG_CURRENCY_SIGNS,
  showKeysForContentManager: initAndGetIsShowTranslationKeys(),
  timeZones: [],
  translations: [],
  isTranslationsInitialized: false
};

const init = ({ DATE_FORMATS, CURRENCY_FORMATS } = {}) =>
  pipe(
    when(
      () => DATE_FORMATS != null,
      over(lensProp('dateFormats'), mergeLeft(DATE_FORMATS))
    ),
    when(
      () => CURRENCY_FORMATS != null,
      assoc('currencyFormats', CURRENCY_FORMATS)
    )
  );

export const useI18nStore = createHookStore(
  STORE_NAMES.I18N,
  initialState,
  null,
  init
);
